import { Link } from "react-router";

export function NotFoundPage() {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
            <h1 className="mb-4 text-4xl font-bold">404</h1>
            <p className="text-muted-foreground mb-6 text-lg">Page not found</p>
            <Link
                to="/"
                className="text-primary-foreground inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium hover:bg-primary/90"
            >
                Go Home
            </Link>
        </div>
    );
}
